import React from 'react';
import MenuItem  from 'material-ui/MenuItem';
import styles from 'styles/components/lib/formElements/controlledSelect.css';

const isEqual=(a, b) =>{
	if (a && b) {

	    // Create arrays of property names
	    var aProps = Object.getOwnPropertyNames(a);
	    var bProps = Object.getOwnPropertyNames(b);

	    // If number of properties is different,
	    // objects are not equivalent
	    if (aProps.length !== bProps.length) {
	        return false;
	    }

	    for (var i = 0; i < aProps.length; i++) {
	        var propName = aProps[i];

	        // If values of same property are not equal,
	        // objects are not equivalent
	        if (a[propName] !== b[propName]) {
	            return false;
	        }
	    }

	    // If we made it this far, objects
	    // are considered equivalent
	    return true;
	} else {
		return false;
	}
}

const getProductionMenuItems = (productions) => {
  let data = [];
  let currentPerformances = [];
  let pastPerformances = [];
  if (productions) {
    productions.sort((a, b) =>
      (a.hasFuturePerformances === b.hasFuturePerformances)
        ? 0
        : a.hasFuturePerformances
          ? -1
          : 1
    );
    for (var i = 0; i < productions.length; i++){
      if(productions[i].hasFuturePerformances === false){
        currentPerformances = productions.slice(0, i);
        pastPerformances = productions.slice(i);
        break;
      }
    }
    currentPerformances.sort((a, b) => (
      a.productionName.toLowerCase() > b.productionName.toLowerCase()) ? 1 : -1
    );
    pastPerformances.sort((a, b) => (
      a.productionName.toLowerCase() > b.productionName.toLowerCase()) ? 1 : -1
    );
    if (Object.keys(currentPerformances).length > 0) {
      data.push({
        text: '',
        value: (
          <MenuItem
            key='Current Series'
            disabled={true}
            className={styles.currentTitle}
            primaryText='Current Series' />
        )
      })
      Object.keys( currentPerformances ).forEach( key => {
        let item = currentPerformances[key];
        data.push(
          { text: item.productionName,
            id:item.productionId,
            value: (
              <MenuItem
              key={`current-${key}`}
              className={styles.menuItem}
              primaryText={item.productionName}
              value={item.productionId} />
            )
          }
        );
      });
    }
    if (Object.keys(pastPerformances).length > 0) {
      data.push({
        text: '',
        value: (
          <MenuItem
            key='Past Series'
          disabled={true}
          className={styles.pastTitle}
          primaryText='Past Series' />
        )
      })
      Object.keys( pastPerformances ).forEach( key => {
        let item = pastPerformances[key];
        data.push(
          { text: item.productionName,
            id:item.productionId,
            value: (
              <MenuItem
              key={`past-${key}`}
              className={styles.pastPerformance}
              primaryText={item.productionName}
              alt={item.productionName}
              value={item.productionId} />
            )
          }
        );
      });
    }
  }
  return data;
}
Object.deepEquals=(obj1,obj2) => {
  if(obj1===obj2) {
    return true;
  }
  if(obj1 && obj2 && typeof obj1 ==="object" && typeof obj2==="object") {
    if(Object.keys(obj1).length!==Object.keys(obj2).length) {
      return false;
    }
    let keys=Object.keys(obj1);
    for(let i=0;i<keys.length;i++) {
      let key=keys[i];
      let areEqual = Object.deepEquals(obj1[key],obj2[key]);
      if(!areEqual) {
        return false;
      }
    }
    return true;
  }
  return obj1 === obj2;
}

const arrObjSorter = (sortKey, ...theArrays) => {
  for(let i = 0; i < theArrays.length; i++) {
    theArrays[i].sort((a,b) => {
      let keyA = a[sortKey];
      let keyB = b[sortKey];
      if(keyA < keyB) return -1;
      if(keyA > keyB) return 1;
      return 0;
    });
  }
  return theArrays;
};

const clone = (obj) =>{
  if (obj === null || typeof(obj) !== 'object')
    return obj;

  if (obj instanceof Date)
    var temp = new obj.constructor();
  else
    var temp = obj.constructor();

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      temp[key] = clone(obj[key]);
    }
  }

  return temp;
}

export {
  isEqual,
  getProductionMenuItems,
  arrObjSorter,
  clone
};



// WEBPACK FOOTER //
// ./src/utils/utils.js